
    import '/opt/buildhome/repo/packages/x/docs/x-sdk/chat-provider.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-x-sdk-chat-provider-demo-default-chat-provider","docs-x-sdk-chat-provider-demo-default-chat-provider-width-ui"],
  getter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/x-sdk/chat-provider.en-US.md?type=demo')
};